<template lang="pug">
div
  Navbar
  section.hero.is-fullheight-with-navbar.podcast-bg
    .hero-body
      .container
        .columns.is-vcentered
          .column.is-one-third
            h1.title.has-text-white Per36 Podcast
            h2.subtitle.has-text-white A basketball podcast with a focus on the Knicks and under-appreciated bench players 
            b-button(type="is-link", tag="a", href="https://twitter.com/Per36Pod", target="_blank")
              font-awesome-icon(:icon="['fab', 'twitter']")
              span  Follow
          .column.is-one-third.is-offset-one-third
            .columns
              .column.is-narrow
                figure.image.is-96x96
                  img.grow-podcast(src="@/assets/podcasts.png", @click="openApple")
              .column.is-narrow
                figure.image.is-96x96
                  img.grow-podcast(src="@/assets/spotify.png", @click="openSpotify")
              .column.is-narrow
                figure.image.is-96x96
                  img.grow-podcast(src="@/assets/anchor.png", @click="openAnchor")
              .column.is-narrow
                figure.image.is-96x96
                  img.grow-podcast(src="@/assets/google-podcasts.png", @click="openGoogle")
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faBookmark } from "@fortawesome/free-solid-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";

import Navbar from "@/components/Navbar.vue";

library.add(faBookmark, faInstagram);

export default {
  name: "Podcast",

  components: {
    Navbar
  },

  methods: {
    openApple() {
      window.open(
        "https://podcasts.apple.com/us/podcast/per-36/id1485406219",
        "_blank"
      );
    },

    openSpotify() {
      window.open(
        "https://open.spotify.com/show/2Ru9BO2LV7mTkBJS7Elwr1",
        "_blank"
      );
    },

    openAnchor() {
      window.open("https://anchor.fm/per36/", "_blank");
    },

    openGoogle() {
      window.open(
        "https://www.google.com/podcasts?feed=aHR0cHM6Ly9hbmNob3IuZm0vcy9lNzQ3NWY4L3BvZGNhc3QvcnNz",
        "_blank"
      );
    }
  }
};
</script>

<style lang="scss">
.podcast-bg {
  background-image: url("../assets/podcast.jpg");
  background-color: black;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.grow-podcast {
  transition: all 0.2s ease-in-out;
  cursor: pointer;
}

.grow-podcast:hover {
  transform: scale(1.05);
}
</style>
